<template>
    <div class="simple-form">
        <el-form :model="authMsuInfo" :rules="authMsuInfoRules" :label-position="'left'" ref="authMsuInfoRule">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">服务商</label>
                </div>
                <div class="form-value base-line">
                    <el-input class="width-1-5x" placeholder="请选择服务商" v-model="authMsuInfo.authMerchantName" disabled></el-input>
                    <i class="icon iconfont icon-chazhaobiaodanliebiao" @click="selectServicerInfo"></i>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权开始时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="distDateFrom">
                        <el-date-picker class="width-1-5x" v-model="authMsuInfo.distDateFrom" type="date" placeholder="开始日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权截止时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="distDateTo">
                        <el-date-picker class="width-1-5x" v-model="authMsuInfo.distDateTo" type="date" placeholder="截止日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="content-caption dashed">
                <span>服务信息</span>
                <span class="swb-btn swb-btn-link" @click="selectMsu">选择服务</span>
            </div>
            <div class="simple-row" v-if="authMsuInfo.authMsuList.length > 0">
                <div class="right">
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="setBasicClaimInfo(null, null,true)">
                        <span>设置价格质量要求</span>
                    </a>
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="setAccClaimInfo(null, null,true)">
                        <span>设置配件要求</span>
                    </a>
                </div>

            </div>
            <div class="table-layout">
                <el-table :data="authMsuInfo.authMsuList" border style="width: 100%">
                    <el-table-column prop="servcName" width="200" label="服务名称" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="title" width="160" label="服务项目名称" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="fixedSpec" width="150" label="规格" align="left"></el-table-column>
                    <el-table-column prop="workHourFee" class-name="required" width="100" label="工时费(元)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.workHourFee'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model="rows.row.workHourFee"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="toDoorFee" class-name="required" width="100" label="上门费(元)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.toDoorFee'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model="rows.row.toDoorFee"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="generallFee" class-name="required" width="100" label="服务费(元)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.generallFee'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model="rows.row.generallFee"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="wrntPeriod" class-name="required" width="100" label="质保期(天)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.wrntPeriod'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.wrntPeriod"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rspTimeMi" class-name="required" width="100" label="响应时长(分)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.rspTimeMi'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.rspTimeMi"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="arriveTimeMi" class-name="required" width="100" label="到达时长(分)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.arriveTimeMi'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.arriveTimeMi"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="repairedTimeMi" class-name="required" width="100" label="修复时长(分)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.repairedTimeMi'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.repairedTimeMi"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="telCallTimeMi" class-name="required" width="100" label="回询时限(分)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.telCallTimeMi'" :rules="{validator: validateNumber, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.telCallTimeMi"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accName" width="100" label="配件名称" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.accName'">
                                <el-input type="text" v-model.number="rows.row.accName"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accSpec" width="100" label="配件规格" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.accSpec'">
                                <el-input type="text" v-model.number="rows.row.accSpec"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accPrice" width="100" label="价格下限(元)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.accPrice'" :rules="{validator: validatePirce, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.accPrice"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="accPrice2" width="100" label="价格上限(元)" align="left">
                        <template slot-scope="rows">
                            <el-form-item :prop="'authMsuList.' + rows.$index + '.accPrice2'" :rules="{validator: validatePirce, trigger: 'blur'}">
                                <el-input type="number" v-model.number="rows.row.accPrice2"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" label="操作" align="left" fixed="right">
                        <template slot-scope="rows">
                            <a class="font14 swb-btn-link" @click="removeMsu(rows.$index)">移除</a>
                            <a class="font14 swb-btn-link" @click="setBasicClaimInfo(rows.row, rows.$index,false)">设置价格质量要求</a>
                            <a class="font14 swb-btn-link" @click="setAccClaimInfo(rows.row, rows.$index,false)">设置配件要求</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { openMsuListDlg } from './selectDlg'
    import { openAuthServicerForSelectDlg } from '../servicer/selectDlg'
    import { openBasicClaimForSelectDlg, openAccClaimForSelectDlg } from '../servcClaim/selectDlg'

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-auth-out-msu-save',
        desc: '授权服务-新增、编辑',
        props: [],
        data: function () {
            let self = this;
            let checkDateStart = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('授权开始时间不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('授权截止时间不能为空!'));
                } else if(value.format("yyyy-MM-dd") < self.authMsuInfo.distDateFrom.format("yyyy-MM-dd")) {
                    callback(new Error('授权截止时间不能比授权开始时间小！'));
                } else if(new Date().format("yyyy-MM-dd") > self.authMsuInfo.distDateTo.format("yyyy-MM-dd")) {
                    callback(new Error('授权截止时间不能比当前时间小！'));
                } else {
                    callback();
                }
            };
            return {
                authMsuInfo: {
                    distDateFrom: null,
                    distDateTo: null,
                    authMsuList: [],
                },
                authMsuInfoRules: {
                    distDateFrom: [{validator: checkDateStart, trigger: 'blur'}],
                    distDateTo: [{validator: checkDateEnd, trigger: 'blur'}],
                }
            }
        },
        created: function () {
            //
        },
        methods: {
            // 选择服务商
            selectServicerInfo: function () {
                let self = this;
                let params = {
                    multiSelect: false
                };
                openAuthServicerForSelectDlg(params, function (returnData) {
                    let authMsuInfo = self.authMsuInfo;
                    authMsuInfo.merchantId = returnData.servicerId;
                    authMsuInfo.authMerchantName = returnData.servicerName;
                    //
                    self.authMsuInfo = Utils.merge({}, authMsuInfo);
                });
            },
            selectMsu: function () {
                let self = this;
                let authMsuInfo = self.authMsuInfo;
                if(Utils.isNoB(authMsuInfo.merchantId)) {
                    MsgBox.warning("请选择服务商！");
                    return;
                }
                //
                openMsuListDlg(true, false, null, function (resultData) {
                    let authMsuList = resultData;
                    // 重置信息
                    for(let i = 0; i < authMsuList.length; i++) {
                        let msuInfo = authMsuList[i];
                        msuInfo.toDoorFee = null;
                        msuInfo.generallFee = null;
                        msuInfo.wrntPeriod = null;
                        msuInfo.rspTimeMi = null;
                        msuInfo.arriveTimeMi = null;
                        msuInfo.repairedTimeMi = null;
                        msuInfo.telCallTimeMi = null;
                        msuInfo.basicClaimId = null;
                        msuInfo.basicClaimVer = null;
                        msuInfo.accClaimId = null;
                        msuInfo.accClaimVer = null;
                        msuInfo.accName = null;
                        msuInfo.accSpec = null;
                        msuInfo.accSrcFlag = null;
                        msuInfo.accPrice = null;
                        msuInfo.accPrice2 = null;
                    }
                    let authMsuInfo = self.authMsuInfo || {};
                    authMsuInfo.authMsuList = Utils.merge([], authMsuList);
                    self.authMsuInfo = Utils.merge({}, authMsuInfo);
                });
            },
            removeMsu: function (index) {
                let authMsuInfo = this.authMsuInfo || {};
                let authMsuList = authMsuInfo.authMsuList || [];
                authMsuList.splice(index, 1);
                //
                authMsuInfo.authMsuList = authMsuList;
                this.authMsuInfo = Utils.merge({}, authMsuInfo);
            },
            setBasicClaimInfo: function (row, index, forAll) {
                // TODO 只查询其他服务的要求
                let self = this;
                let showInfo = false;
                //
                if(forAll) {
                    let authMsuInfo = self.authMsuInfo || {};
                    let authMsuList = authMsuInfo.authMsuList || [];
                    let firstMsuInfo = authMsuList[0];
                    for(let i = 0; i < authMsuList.length; i++) {
                        let msuInfo = authMsuList[i];
                        if(firstMsuInfo.ssu.type != msuInfo.ssu.type) {
                            showInfo = true;
                        }
                    }
                }
                if(showInfo) {
                    self.$confirm('所选服务非同服务类型是否继续', '提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.setBaseInfo2(row, index, forAll);
                    }).catch(function () {
                    });
                } else {
                    self.setBaseInfo2(row, index, forAll);
                }
            },
            setBaseInfo2: function (row, index, forAll) {
                let self = this;
                let servcTypeId = null;
                if(!Utils.isNoB(row)) {
                    servcTypeId = row.ssu.type;
                }
                let params = {
                    servcTypeId: servcTypeId,
                    forAuthFlag: true
                };
                openBasicClaimForSelectDlg(params, function (resultData) {
                    let authMsuInfo = self.authMsuInfo || {};
                    let authMsuList = authMsuInfo.authMsuList;
                    if(forAll) {
                        for(let i = 0; i < authMsuList.length; i++) {
                            let msuInfo = authMsuList[i];
                            msuInfo.toDoorFee = resultData.toDoorFee;
                            msuInfo.generallFee = resultData.generallFee;
                            msuInfo.wrntPeriod = resultData.wrntPeriod;
                            msuInfo.rspTimeMi = resultData.rspTimeMi;
                            msuInfo.arriveTimeMi = resultData.arriveTimeMi;
                            msuInfo.repairedTimeMi = resultData.repairedTimeMi;
                            msuInfo.telCallTimeMi = resultData.telCallTimeMi;
                            msuInfo.basicClaimId = resultData.id;
                            msuInfo.basicClaimVer = resultData.version;
                        }
                    } else {
                        let msuInfo = authMsuList[index];
                        msuInfo.toDoorFee = resultData.toDoorFee;
                        msuInfo.generallFee = resultData.generallFee;
                        msuInfo.wrntPeriod = resultData.wrntPeriod;
                        msuInfo.rspTimeMi = resultData.rspTimeMi;
                        msuInfo.arriveTimeMi = resultData.arriveTimeMi;
                        msuInfo.repairedTimeMi = resultData.repairedTimeMi;
                        msuInfo.telCallTimeMi = resultData.telCallTimeMi;
                        msuInfo.basicClaimId = resultData.id;
                        msuInfo.basicClaimVer = resultData.version;
                    }
                    authMsuInfo.authMsuList = authMsuList;
                    self.authMsuInfo = Utils.merge({}, authMsuInfo);
                });
            },
            setAccClaimInfo: function (row, index, forAll) {
                let self = this;
                let showInfo = false;
                //
                if(forAll) {
                    let authMsuInfo = self.authMsuInfo || {};
                    let authMsuList = authMsuInfo.authMsuList || [];
                    let firstMsuInfo = authMsuList[0];
                    for(let i = 0; i < authMsuList.length; i++) {
                        let msuInfo = authMsuList[i];
                        if(firstMsuInfo.ssu.type != msuInfo.ssu.type) {
                            showInfo = true;
                        }
                    }
                }
                if(showInfo) {
                    self.$confirm('所选服务非同服务类型是否继续', '提示', {
                        confirmButtonText: '继续',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        self.setAccInfo(row, index, forAll);
                    }).catch(function () {
                    });
                } else {
                    self.setAccInfo(row, index, forAll);
                }
            },
            setAccInfo: function (row, index, forAll) {
                // TODO 只查询其他服务的要求
                let self = this;
                let servcTypeId = null;
                let servcCatId = null;
                if(!Utils.isNoB(row)) {
                    servcTypeId = row.ssu.type;
                    servcCatId = row.catId;
                }
                let params = {
                    servcTypeId: servcTypeId,
                    servcCatId: servcCatId,
                    forAuthFlag: true
                };
                openAccClaimForSelectDlg(params, function (resultData) {
                    let authMsuInfo = self.authMsuInfo || {};
                    let authMsuList = authMsuInfo.authMsuList;
                    if(forAll) {
                        for(let i = 0; i < authMsuList.length; i++) {
                            let msuInfo = authMsuList[i];
                            msuInfo.accName = resultData.name;
                            msuInfo.accSpec = resultData.spec;
                            msuInfo.accSrcFlag = resultData.srcFlag;
                            msuInfo.accPrice = resultData.price;
                            msuInfo.accPrice2 = resultData.price2;
                            msuInfo.accClaimId = resultData.id;
                            msuInfo.accClaimVer = resultData.version;
                        }
                    } else {
                        let msuInfo = authMsuList[index];
                        msuInfo.accName = resultData.name;
                        msuInfo.accSpec = resultData.spec;
                        msuInfo.accSrcFlag = resultData.srcFlag;
                        msuInfo.accPrice = resultData.price;
                        msuInfo.accPrice2 = resultData.price2;
                        msuInfo.accClaimId = resultData.id;
                        msuInfo.accClaimVer = resultData.version;
                    }
                    authMsuInfo.authMsuList = authMsuList;
                    self.authMsuInfo = Utils.merge({}, authMsuInfo);
                });
            },
            validatePirce: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isNumber(value)) {
                        callback(new Error('请输入正确的数'));
                    } else {
                        callback();
                    }
                }
            },
            validateNumber: function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if(!Utils.isNumber(parseFloat(value)) || value <= 0) {
                        callback(new Error('请输入大于0的数'));
                    } else {
                        callback();
                    }
                }
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let authMsuInfo = self.authMsuInfo;
                if(Utils.isNoB(authMsuInfo.merchantId)) {
                    result.type = "warn";
                    result.message = "请选择服务商";
                    return result;
                }
                this.$refs['authMsuInfoRule'].validate(function (valid) {
                    if(valid) {
                        let authMsuList = authMsuInfo.authMsuList || [];
                        if(Utils.isNoB(authMsuList) || authMsuList.length <= 0) {
                            result.type = "warn";
                            result.message = "请选择服务";
                        } else {
                            result.type = "info";
                            //
                            authMsuInfo.authMsuList.forEach(function (item) {
                                if(Utils.isNoB(item.accPrice)) {
                                    item.accPrice = 0;
                                }
                                if(Utils.isNoB(item.accPrice2)) {
                                    item.accPrice2 = 0;
                                }
                            });
                            authMsuInfo.distDateFrom = authMsuInfo.distDateFrom.format("yyyy-MM-dd");
                            authMsuInfo.distDateTo = authMsuInfo.distDateTo.format("yyyy-MM-dd");
                            result.data = authMsuInfo;
                        }
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/AuthOutMsuSave.vue